import React from 'react'
import { User } from 'lucide-react'
import { getAvatarUrl } from '../lib/avatars'
import { cn } from '../lib/utils'

// Round profile-photo bubble keyed on the user UUID. Renders the
// per-user photo (custom-uploaded → seed → placeholder) at the
// requested pixel size.
//
// Use this anywhere a partner / owner name is shown AS A LABEL
// (column header, progress row, score block). Skip it when the name
// is interpolated into a sentence — per the owner's rule the avatar
// only travels with the label form, not the prose form.
export default function Avatar({ userId, profile = null, size = 24, className }) {
  const url = getAvatarUrl(userId, profile)
  const dimensionPx = `${size}px`
  const sharedStyle = { width: dimensionPx, height: dimensionPx }

  if (url) {
    return (
      <img
        src={url}
        alt=""
        style={sharedStyle}
        className={cn(
          'rounded-full object-cover flex-shrink-0 border border-border/40',
          className,
        )}
        loading="lazy"
        draggable={false}
      />
    )
  }

  // No avatar known → muted circle with the generic User glyph.
  // Same dimensions so the surrounding layout stays stable when the
  // identity-side avatar resolves vs the partner-side falls back.
  return (
    <span
      style={sharedStyle}
      className={cn(
        'rounded-full bg-muted text-muted-foreground inline-flex items-center justify-center flex-shrink-0',
        className,
      )}
      aria-hidden="true"
    >
      <User style={{ width: size * 0.6, height: size * 0.6 }} />
    </span>
  )
}
